import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  DictionaryEvidence,
  FormFileField,
  FormPanel,
  FormTextField,
} from '@eas/common-web';

export function Fields() {
  const intl = useIntl();
  return (
    <>
      <DictionaryEvidence.FieldName />
      <DictionaryEvidence.FieldCode />
      <DictionaryEvidence.FieldOrder />
      <DictionaryEvidence.FieldActive />

      <FormPanel
        label={
          <FormattedMessage
            id="EAS_CERTIFICATES_PANEL_TITLE"
            defaultMessage="Certifikát"
          />
        }
      >
        <FormFileField
          name="content"
          required
          label={
            <FormattedMessage
              id="EAS_CERTIFICATES_FIELD_LABEL_CONTENT"
              defaultMessage="Obsah"
            />
          }
          helpLabel={intl.formatMessage({
            id: 'EAS_CERTIFICATES_FIELD_HELP_CONTENT',
            defaultMessage: 'PFX, P12 nebo JKS soubor',
          })}
        />
        <FormTextField
          name="password"
          required
          type="password"
          label={
            <FormattedMessage
              id="EAS_CERTIFICATES_FIELD_LABEL_PASSWORD"
              defaultMessage="Heslo"
            />
          }
          helpLabel={intl.formatMessage({
            id: 'EAS_CERTIFICATES_FIELD_HELP_PASSWORD',
            defaultMessage: ' ',
          })}
        />
      </FormPanel>
    </>
  );
}
